export default __webpack_public_path__ + "static/media/micro-required-yeast.819f471a.png";